define('SageDotCom/Components/CareerSearch',["Pagination",
    "knockout",
    "underscore",
    "eventManager",
    "jqueryChosen",
    "jqueryQuerystring",
    "knockoutChosen"
],
    function ($, ko, _, eventManager) {

        function CareerSearch(scope, seeAllLabel, pageSize, navigator, totalResultsLabel, keywordPlaceholder) {
            Object.defineProperties(this, {
                $scope: { enumerable: true, value: $(scope) }
            });

            function CallController() {

                $(".career-search:not(.old) .results").css({ "visibility": "hidden" });
                $(".desktop-right-side") ? addSpinner($(".desktop-right-side")) : $(".desktop-right-side");

                $.getJSON("/api/sagedotcom/CareerSearch/GetCareerSearchData", null, function (data) {
                    if (typeof (data) !== "undefined" && data !== null) {

                        var pageData = [];
                        var view = new CareersViewModel(data.vacancies.Records, data.vacancies.TotalSize, pageData);

                        setPagination(pageData, data.vacancies.Records, view);
                        ko.applyBindings(view);
                        var keywords = $.Querystring("keywords");
                        var func = $.Querystring("function");
                        var country = $.Querystring("country");
                        var city = $.Querystring("city");
                        var page = $.Querystring("page");
                        var hasQuery = false;
                        var hasPage = false;
                        if (typeof (keywords) !== "undefined" && keywords !== null) {
                            view.keywords(keywords);
                            hasQuery = true;
                        }
                        if (typeof (func) !== "undefined" && func !== null) {
                            view.selectedFunction(func);
                            hasQuery = true;
                        }
                        if (typeof (country) !== "undefined" && country !== null) {
                            view.selectedCountry(country);
                            hasQuery = true;
                            if (typeof (city) !== "undefined" && city !== null) {
                                view.selectedLocations(city.split(";"));
                            }
                        }
                        if (typeof (page) !== "undefined" && page !== null) {
                            $('#pagination-container').pagination('go', page);
                            view.page = page;
                            view.hasPage = true;
                            hasPage = true;
                        }
                        if (hasQuery) {
                            view.updateResults(false, false);
                        } else if (history.pushState && !hasPage) {
                            history.pushState("", "", "?page=1");
                        }
                        setDotSeperatorAndCountryIcon();

                        var inputWidth = $(".career-search .keyword-container.mobile").width() - $(".career-search .keyword-container.mobile .search").width() - 40;

                        if ($(".career-search .keyword-container.mobile .keyword").val() == "" && $(".career-search .keyword-container.desktop .keyword").val() == "") {
                            // keyword search must be empty so remove cross icon from box
                            [].forEach.call(document.querySelectorAll(".career-search .keyword-container .close-icon-container"), function (el) {
                                $(el).css("display", "none");
                                $(el).attr("tabindex", "-1");
                            });
                            $(".career-search .keyword-container.mobile .keyword").css("width", inputWidth - 50);
                        }
                        else {
                            [].forEach.call(document.querySelectorAll(".career-search .keyword-container .close-icon-container"), function (el) {
                                $(el).css("display", "inline-block");
                                $(el).attr("tabindex", "0");
                            });
                            $(".career-search .keyword-container.mobile .keyword").css("width", inputWidth - 88);
                        }

                        //find selected function if applicable and add selected class
                        selectedFunctionStyling(func);

                        $(".desktop-right-side") ? removeSpinner($(".desktop-right-side")) : $(".desktop-right-side");
                        $(".career-search:not(.old) .results").css({ "visibility": "visible" });
                    }
                });
            }
            var lastPage = 1;
            function setPagination(pageData, dataSource, view) {
                $('#pagination-container').pagination({
                    dataSource: dataSource,
                    pageSize: pageSize,
                    formatNavigator: '<div class=\'stats\'>' + navigator + '</div>',
                    autoHidePrevious: true,
                    autoHideNext: true,
                    callback: function (data, pagination) {
                        pageData = data;
                        view.jobs(data);
                        var fromNumber = pagination.pageNumber * pagination.pageSize - (pagination.pageSize - 1);
                        var toNumber = data.length < pagination.pageSize ? pagination.totalNumber : pagination.pageNumber * pagination.pageSize;
                        if (toNumber !== 0) {
                            var paginationStatsLabel = navigator.replace("STARTNUMBER", fromNumber + ' - ' + toNumber);
                            paginationStatsLabel = paginationStatsLabel.replace("TOTALNUMBER", pagination.totalNumber);

                            $(".stats", scope).html(paginationStatsLabel);

                            // update the number of results in results label and keyword search box
                            var keywordPlaceholderUpdated = keywordPlaceholder.replace("TOTALNUMBER", pagination.totalNumber);
                            var totalResultsLabelUpdated = totalResultsLabel.replace("TOTALNUMBER", pagination.totalNumber);
                            [].forEach.call(document.querySelectorAll(".keyword"), function (el) {
                                el.placeholder = keywordPlaceholderUpdated;
                            });
                            $(".results-number", scope).html(totalResultsLabelUpdated);

                        } else {
                            $(".stats", scope).html("");
                            var keywordPlaceholderUpdated = keywordPlaceholder.replace("TOTALNUMBER", "0");
                            [].forEach.call(document.querySelectorAll(".keyword"), function (el) {
                                el.placeholder = keywordPlaceholderUpdated;
                            });
                        }
                        if (pagination.pageNumber != lastPage) {
                            lastPage = pagination.pageNumber;
                            eventManager.trigger("facet-selected", scope, null, "Page", pagination.pageNumber);
                            $(".career-search").parent().get(0).scrollIntoView();
                        }
                        
                    },
                    afterPageOnClick: function () {
                        pageData = $('#pagination-container').pagination('getSelectedPageData');
                        var pageNum = $('#pagination-container').pagination('getSelectedPageNum');
                        if (history.pushState) {
                            //get the query string re-assign page attr
                            var queryString = location.search;
                            if (queryString.indexOf("page=") !== -1) {
                                queryString = queryString.replace(/page=(\d+)/gi, "page=" + pageNum);
                            }
                            history.pushState("", "", queryString);
                        }
                        view.jobs(pageData);   
                        eventManager.trigger("add-aria-labels-to-pagination");
                        setDotSeperatorAndCountryIcon();
                    },
                    afterNextOnClick: function() {
                        eventManager.trigger("add-aria-labels-to-pagination");
                        setDotSeperatorAndCountryIcon();
                    },
                    afterPreviousOnClick: function () {
                        eventManager.trigger("add-aria-labels-to-pagination");
                        setDotSeperatorAndCountryIcon();
                    }
                });
            }

            function CareersViewModel(data, totalSize, pageData) {

                var self = this;
                self.hasPage = false;
                self.page = 1;
                self.seeAll = seeAllLabel + "(" + totalSize + ")";

                self.allJobs = data;
                self.selectedCountry = ko.observable();

                self.selectedFunction = ko.observable();

                self.selectedLocations = ko.observableArray();
                 
                self.selectedCountry.subscribe(function (value) {
                    eventManager.trigger("facet-selected", scope, self.keywords(), "Country", value);
                });
                self.selectedFunction.subscribe(function (value) {
                    eventManager.trigger("facet-selected", scope, self.keywords(), "Function", value);
                });
                self.selectedLocations.subscribe(function (value) {
                    eventManager.trigger("facet-selected", scope, self.keywords(), "Location", value);
                });

                self.keywords = ko.observable();
                
                self.countries = ko.computed(function () {
                    var listOfAllCountries = ko.utils.arrayMap(data,
                        function (item) {
                            return { country: item.Country, locations: item.OfficeLocation ? item.OfficeLocation.split(";") : "" };
                        });
                    var uniqueList = [];
                    _.each(listOfAllCountries, function (country) {
                        var filtered = listOfAllCountries.filter(function (item) {
                            return item.country === country.country;
                        });
                        var checkUnique = uniqueList.filter(function (item) {
                            return item.country === country.country;
                        });
                        if (filtered.length > 1 && checkUnique.length === 0) {
                            var locations = [];
                            _.each(filtered,
                                function (item) {
                                    locations = locations.concat(item.locations);
                                });
                            locations = ko.utils.arrayGetDistinctValues(locations).sort();
                            uniqueList.push({ country: country.country, locations: locations });
                        } else if (checkUnique.length === 0) {
                            uniqueList.push({ country: country.country, locations: country.locations });
                        }

                    });
                    return uniqueList;
                });

                self.functions = ko.computed(function () {
                    var functions = ko.utils.arrayMap(data, function (item) { return { function: item.Function }; });
                    var notNullFunctions = [];

                    _.each(functions, function (item) {
                        if ( item.function !== null) {
                            notNullFunctions.push(item.function);
                        }
                    });
                    return ko.utils.arrayGetDistinctValues(notNullFunctions).sort();
                });

                self.functionsText = ko.computed(function () {

                    // need to calculate how many jobs of each function there are to populate the number in the career filter
                    var selectedCountry = self.selectedCountry();
                    var keyword = self.keywords();
                    var functions = ko.utils.arrayMap(data, function (item) { return { function: item.Function, country: item.Country, desc: item.Description, name: item.Name }; });

                    var hasCountrySelected = typeof selectedCountry !== 'undefined' && selectedCountry !== "";
                    var hasKeywordPopulated = typeof keyword !== 'undefined' && keyword !== "";

                    // these two list will be used to hold the function of the jobs that either match/dont match the applied filter accordingly
                    var jobsThatMatchFilter = [];
                    var jobsThatDontMatchFilter = [];

                    if (hasCountrySelected && hasKeywordPopulated) {
                        _.each(functions, function (item) {
                            var keywordMatchesDescription = item.desc != null && item.desc.toLowerCase().indexOf(keyword.toLowerCase()) !== -1;
                            var keywordMatchesName = item.name != null && item.name.toLowerCase().indexOf(keyword.toLowerCase()) !== -1;

                            if (item.country === selectedCountry && (keywordMatchesDescription || keywordMatchesName) && item.function !== null) {
                                jobsThatMatchFilter.push(item.function);
                            }
                            else {
                                if(item.function !== null){
                                    jobsThatDontMatchFilter.push(item.function);
                                }
                            }
                        });
                    }
                    else if (hasCountrySelected && !hasKeywordPopulated) {
                        _.each(functions, function (item) {
                            if (item.country === selectedCountry && item.function !== null) {
                                jobsThatMatchFilter.push(item.function);
                            }
                            else {
                                if (item.function !== null) {
                                    jobsThatDontMatchFilter.push(item.function);
                                }
                            }
                        });
                    }
                    else if (!hasCountrySelected && hasKeywordPopulated) {
                        _.each(functions, function (item) {
                            var keywordMatchesDescription = item.desc != null && item.desc.toLowerCase().indexOf(keyword.toLowerCase()) !== -1;
                            var keywordMatchesName = item.name != null && item.name.toLowerCase().indexOf(keyword.toLowerCase()) !== -1;

                            if ((keywordMatchesDescription || keywordMatchesName) && item.function !== null) {
                                jobsThatMatchFilter.push(item.function);
                            }
                            else {
                                if (item.function !== null) {
                                    jobsThatDontMatchFilter.push(item.function);
                                }
                            }
                        });
                    }
                    else {
                        _.each(functions, function (item) {
                            if (item.function !== null) {
                                jobsThatMatchFilter.push(item.function);
                            }
                        });
                    }
                    
                    var countFunctions = 1;
                    var totalFunctions = 0;
                    var finalListOfFunctions = [];
                    if (typeof jobsThatMatchFilter !== 'undefined') {
                        for (let i = 0; i < jobsThatMatchFilter.length; i++) {
                            var indexOf = jobsThatMatchFilter.indexOf(jobsThatMatchFilter[i]);
                            // only get distinct functions (eg. do not add "People" function to final list twice)
                            if (indexOf === i) {
                                for (let j = i + 1; j < jobsThatMatchFilter.length; j++) {
                                    // check if elements' values are equal
                                    if (jobsThatMatchFilter[i] === jobsThatMatchFilter[j]) {
                                        // duplicate element present increase count of occurence
                                        countFunctions++;
                                    }
                                }
                                finalListOfFunctions.push(jobsThatMatchFilter[i] + " (" + countFunctions + ")");
                                totalFunctions = totalFunctions + countFunctions;
                                countFunctions = 1;
                            }
                        }
                    }
                    if (typeof jobsThatDontMatchFilter !== 'undefined') {
                        for (let i = 0; i < jobsThatDontMatchFilter.length; i++) {
                            var indexOf = jobsThatDontMatchFilter.indexOf(jobsThatDontMatchFilter[i]);
                            //check if elements are not repeated
                            if (indexOf === i) {
                                var isInOtherList = jobsThatMatchFilter.indexOf(jobsThatDontMatchFilter[i]);
                                if (isInOtherList < 0) {
                                    finalListOfFunctions.push(jobsThatDontMatchFilter[i] + " (0)");
                                }
                            }
                        }
                    }

                    // set value of number in all department placeholder in dekstop to correct number
                    var allFunctionDepartmentText = $(".all-functions", scope).text() ? $(".all-functions", scope).text().replace(/[\s+\(\d+\)]*$/g, "") : $(".all-functions", scope);
                    allFunctionDepartmentText = allFunctionDepartmentText + " (" + totalFunctions + ")";
                    $(".all-functions", scope).text(allFunctionDepartmentText);
                    $(".all-functions", scope).attr("aria-label", allFunctionDepartmentText);

                    return ko.utils.arrayGetDistinctValues(finalListOfFunctions).sort();
                });

                var fullFunction = function (value, name) {
                    this.functionValue = value;
                    this.functionName = name;
                };

                self.availableFunctions = ko.computed(function () {

                    var values = self.functions();
                    var names = self.functionsText();

                    var listOfFullFunctions = [];

                    _.each(values, function (value) {
                        _.each(names, function (name) {
                            var temp = name.replace(/[\s+\(\d+\)]*$/g, "");
                            if (temp === value) {
                                var newFunction = new fullFunction(value, name);
                                listOfFullFunctions.push(newFunction);
                                return;
                            }
                        });
                    });
                    return ko.utils.arrayGetDistinctValues(listOfFullFunctions).sort();
                });
                    
                self.locations = ko.computed(function () {
                    var country = self.selectedCountry();
                    var filtered = ko.utils.arrayFirst(self.countries(), function (item) {
                        return item.country === country;
                    });
                    if (!filtered) {
                        return [];
                    } else {
                        return filtered.locations;
                    }
                });
                self.jobs = ko.observableArray(pageData);

                self.updateResults = function (scrollToResults, addSpinner) {

                    if (addSpinner || addSpinner == null) {
                        $(".career-search:not(.old) .results").css({ "visibility": "hidden" });
                        $(".desktop-right-side") ? self.addSpinnerFromSelf($(".desktop-right-side")) : $(".desktop-right-side");
                    }

                    var keyword = self.keywords();
                    var func = self.selectedFunction();
                    var country = self.selectedCountry();
                    var locations = self.selectedLocations();
                    var jobs = self.allJobs;
                    var queryString = "?";

                    func = func ? func.replace(/[\s+\(\d+\)]*$/g, "") : func;

                    if (!keyword) {
                    } else {
                        jobs = ko.utils.arrayFilter(jobs,
                            function (item) {
                                return ((item.Description !== null && item.Description.toLowerCase().indexOf(keyword.toLowerCase()) !== -1) ||
                                    (item.Name !== null && item.Name.toLowerCase().indexOf(keyword.toLowerCase()) !== -1));
                            });
                        queryString += "keywords=" + keyword + "&";
                    }
                    if (!func) {
                    } else {
                        jobs = ko.utils.arrayFilter(jobs,
                            function (item) {
                                return item.Function === func;
                            });
                        queryString += "function=" + func + "&";
                    }
                    if (!country) {
                    } else {
                        jobs = ko.utils.arrayFilter(jobs,
                            function (item) {
                                return item.Country === country;
                            });

                        queryString += "country=" + country + "&";
                    }
                    if (locations.length) {
                        jobs = ko.utils.arrayFilter(jobs, function (item) {
                            if (item.OfficeLocation == null) {
                                return false;
                            }

                            var jobLocation = item.OfficeLocation.split(";");
                            return locations.some(function (r) {
                                return jobLocation.indexOf(r) >= 0;
                            });
                        });
                        queryString += "city=" + locations.join(";") + "&";
                    }
                    if (queryString.length > 1 && history.pushState && !self.hasPage) {
                        history.pushState("", "", queryString + "page=1");
                    } else if (queryString.length > 1 && history.pushState && self.hasPage) {
                        history.pushState("", "", queryString + "page=" + self.page);
                    }
                    self.jobs(jobs);
                    //update whole pagination with new data set 
                    setPagination(pageData, ko.toJS(self.jobs()), self);
                    eventManager.trigger("search-triggered", scope, keyword);

                    setDotSeperatorAndCountryIcon();
                    self.findFunctionText();

                    if (addSpinner || addSpinner == null) {
                        $(".desktop-right-side") ? removeSpinner($(".desktop-right-side")) : $(".desktop-right-side");
                        $(".career-search:not(.old) .results").css({ "visibility": "visible" });
                    }
                    
                    if (scrollToResults == null || scrollToResults) {
                        $([document.documentElement, document.body]).animate({
                            scrollTop: $(".results").offset().top - 80
                        }, 1000);
                    }

                };
                self.showAll = function () {
                    self.keywords("");
                    self.selectedFunction("");
                    self.selectedCountry("");
                    self.selectedLocations([]);
                    self.jobs(self.allJobs.slice(0, pageSize));
                    self.findFunctionText();
                    if (history.pushState) {
                        history.pushState("", "", "?page=1");
                    }
                    eventManager.trigger("search-triggered", scope, "");
                    
                    setPagination(pageData, ko.toJS(self.allJobs), self);

                    $(document.querySelector(".career-search .function .form-control.selected")).removeClass("selected");
                    $(document.querySelector(".career-search .function .all-functions")).addClass("selected");
                    [].forEach.call(document.querySelectorAll(".career-search .keyword-container .close-icon-container"), function (el) {
                        $(el).css("display", "none");
                        $(el).attr("tabindex", "-1");
                    });
                    setDotSeperatorAndCountryIcon();
                };

                self.findFunctionText = function () {
                    var functionTexts = self.functionsText();
                    var functionValues = self.functions();

                    // need to update the numbers next to each function 
                    [].forEach.call(document.querySelectorAll(".career-search .function.desktop .form-control"), function (el) {

                        var functionTextFromHtml = $(el).text() ? $(el).text().replace(/[\s+\(\d+\)]*$/g, "") : $(el).text();
                        _.each(functionTexts, function (func) {
                            var functionTextFromComputed = func ? func.replace(/[\s+\(\d+\)]*$/g, "") : func;

                            if (functionTextFromComputed === functionTextFromHtml) {
                                $(el).text(func);
                                $(el).attr("aria-label", func);
                            }
                        });
                    });
                };

                self.clearKeyword = function (clearKeywordValue) {
                    self.keywords(clearKeywordValue);
                    self.updateResults(false);

                    var newInputWidth = $(".career-search .keyword-container.mobile").width() - $(".career-search .keyword-container.mobile .search").width() - 40;
                    [].forEach.call(document.querySelectorAll(".career-search .keyword-container .close-icon-container"), function (el) {
                        $(el).css("display", "none");
                        $(el).attr("tabindex", "-1");
                    });
                    $(".career-search .keyword-container.mobile .keyword").css("width", newInputWidth - 50);
                };

                self.clearKeywordKeypress = function (data, event) {
                    if (event.keyCode === 13) {
                        self.keywords('');
                        self.updateResults(false);

                        var newInputWidth = $(".career-search .keyword-container.mobile").width() - $(".career-search .keyword-container.mobile .search").width() - 40;
                        [].forEach.call(document.querySelectorAll(".career-search .keyword-container .close-icon-container"), function (el) {
                            $(el).css("display", "none");
                            $(el).attr("tabindex", "-1");
                        });
                        $(".career-search .keyword-container.mobile .keyword").css("width", newInputWidth - 50);
                    }
                };

                self.updateKeywordResultsOnEnter = function (data, event) {
                    if (event.keyCode === 13) {
                        self.updateResults();
                    }
                };

                self.updateCountry = function (data, event) {
                    self.selectedCountry(event.target.value);
                    self.updateResults(false);
                };

                self.updateFunctionFromSelect = function (data, event) {
                    self.selectedFunction(event.target.value);
                    self.updateResults(false);
                    selectedFunctionStyling(self.selectedFunction());
                };

                self.updateFunction = function (functionToUpdate) {
                    self.selectedFunction(functionToUpdate)
                    self.updateResults(false);
                    selectedFunctionStyling(functionToUpdate);
                };

                self.moveFunctionFocus = function (data, event) {
                    // need to be able to use arrow keys to move between department list options
                    if (event.keyCode === 39 || event.keyCode === 40) {
                        if ($(".function-option:focus").hasClass("all-functions")) {
                            $(".function-option:focus").next().children(":first").focus();
                        }
                        else {
                            $(".function-option:focus").next().focus();
                        }
                    }
                    else if (event.keyCode === 37 || event.keyCode === 38) {
                        if (!($(".function-option:focus").prev().hasClass("function-option"))) {
                            $(".function-option.all-functions").focus();
                        }
                        else {
                            $(".function-option:focus").prev().focus();
                        }

                    }
                };

                self.jobSelected = function (job) {
                    var keyword = self.keywords();
                    var func = self.selectedFunction();
                    var country = self.selectedCountry();
                    var locations = self.selectedLocations();

                    var facets = "";
                    if (func) {
                        facets += "Function: " + func + "; ";
                    }
                    if (country) {
                        facets += "Country: " + country + "; ";
                    }
                    if (locations && locations.length >= 1) {
                        facets += "Locations: ";
                        locations.forEach(function (location) {
                            facets += location + ",";
                        });
                    }

                    eventManager.trigger("search-result-selected", scope, keyword, facets, job.Name);
                    window.open(job.Url, '_blank');
                };

                self.jobSelectedKeypress = function (job, event) {
                    if (event.keyCode === 13) {
                        self.jobSelected(job);
                    }
                };

                self.addSpinnerFromSelf = function (context) {
                    context.append("<div class='loader'></div>");
                    var spinner = context.find(".loader");
                    spinner != null && spinner != undefined ? spinner.insertBefore(spinner.prev()) : spinner;
                }

                self.setAriaLabels = function (option, item) {
                    option.setAttribute("aria-label", option.text);
                }
            }

            function setDotSeperatorAndCountryIcon() {
                [].forEach.call(document.querySelectorAll(".career-search .results-list .single-result"), function (el) {

                    // generate the css class to add to find the correct country flag
                    var country = $(el).find(".country-location").text();
                    country = country ?  "icon-" + country.toLowerCase().replaceAll(" ", "-") : country;
                    $(el).find(".country-flag-icon").addClass(country);

                    // replace the ";" seperating office locations with a html bullet
                    var inner = el.querySelectorAll(".office-location");
                    var offices = $(el).find(".office-location").text();
                    var replacementString = '<span class="dot-separator">&bull;</span>';


                    if (offices !== null && offices !== undefined && offices != "") {
                        var newText = offices.replaceAll(';', replacementString);
                        $(inner)[0].innerHTML = newText;
                    }
                });

                if ($(document).width() >= 1080) {
                    // need to manually set the height of the career search component to avoid overlap with footer
                    var newHeight = $(".sage-career-search").height() > $(".desktop-right-side").height() ? $(".sage-career-search").height() : $(".desktop-right-side").height();
                    $(".career-search").css("height", newHeight);
                }
                else {
                    $(".career-search").css("height", $(".sage-career-search").height() + $(".desktop-right-side").height() + 150);
                }
            }

            function selectedFunctionStyling(functionToSelect) {
                $(document.querySelector(".career-search .function .form-control.selected")).removeClass("selected");

                [].forEach.call(document.querySelectorAll(".career-search .function .form-control"), function (el) {

                    var functionText = $(el).text() ? $(el).text().replace(/[\s+\(\d+\)]*$/g, "") : $(el).text();

                    if (functionText == functionToSelect) {
                        $(el).addClass("selected");
                    }
                    else if ($(el).hasClass("all-functions") && (functionToSelect == '' || functionToSelect == undefined || functionToSelect == null)) {
                        $(el).addClass("selected");
                    }
                });
            }

            function addSpinner(context) {
                context.append("<div class='loader'></div>");
                var spinner = context.find(".loader");
                spinner != null && spinner != undefined ? spinner.insertBefore(spinner.prev()) : spinner;
            }

            function removeSpinner(context) {
                var spinner = context.find(".loader");
                spinner != null && spinner != undefined ? spinner.remove() : spinner;
            }

            CallController();
        }

        return function init(args) {
            return args.IsExperienceEditorEditing ? null : new CareerSearch(args.scope, args.seeAllLabel, args.pageSize, args.navigator, args.totalResultsLabel, args.keywordPlaceholder);
        };
    });


